import { ReadonlyJSONObject, ReadTransaction, WriteTransaction } from "@workcanvas/reflect";
import {
  canvasElementPrefix,
  getUnixTimestampUTC,
  validateSchema,
  authenticatedPut,
  authenticatedDelete,
  createElementId,
} from "../util/utils";
import { Point } from "./schemas/canvas-element";
import { CommentThread, commentThreadSchema } from "./schemas/comment-thread";

export async function getCommentThread(tx: ReadTransaction, id: string): Promise<CommentThread | null> {
  const jv = await tx.get(key(id));
  if (!jv) {
    console.log(`Specified thread ${id} not found.`);
    return null;
  }
  return validateSchema(commentThreadSchema, jv);
}

export function putCommentThread(
  tx: WriteTransaction,
  { id, thread }: { id: string; thread: CommentThread }
): Promise<void> {
  const next = { ...(thread as ReadonlyJSONObject), lastModifiedTimestamp: getUnixTimestampUTC() };
  return authenticatedPut(tx, key(id), next);
}

export async function deleteCommentThread(tx: WriteTransaction, id: string): Promise<void> {
  await authenticatedDelete(tx, key(id));
}

export async function moveCommentThread(
  tx: WriteTransaction,
  { id, dx, dy }: { id: string; dx: number; dy: number }
): Promise<void> {
  const thread = await getCommentThread(tx, id);
  if (thread) {
    thread.x += dx;
    thread.y += dy;
    await putCommentThread(tx, { id, thread });
  }
}

export const commentThreadPrefix = `${canvasElementPrefix}comment-`;

function key(id: string): string {
  return `${commentThreadPrefix}${id}`;
}

export function placeCommentThread(point: Point, placedBy: { id?: string | null; thumbnail?: string | null }) {
  const id = createElementId();
  return {
    id,
    thread: {
      x: point.x,
      y: point.y,
      scaleX: 1,
      scaleY: 1,
      hidden: false,
      zIndexLastChangeTime: getUnixTimestampUTC(),
      store: "cord",
      storeId: id,
      placedByUser: placedBy.id ?? undefined,
      userPhotoUrl: placedBy.thumbnail ?? undefined,
    } as CommentThread,
  };
}
